import React from 'react'

import { Container, Row, Col, Button } from 'reactstrap'

import './style/style.scss'

export const AuthFail = () => (
  <Container className="auth">
    <Row>
      <Col>
        <h2 className="header head-1">Sorry for the delay!</h2>
        <p className="text-normal margin-top-40 padding-bottom-40">
          If you recently registered, it could take up to 24 hours for your
          credentials to be transferred to this portal. For immediate
          assistance, please email{' '}
          <a href="mailto:providers@centivo.com" className="link">
            providers@centivo.com
          </a>{' '}
          .
        </p>
        <div className="text-center margin-top-40">
          <Button color="secondary" className="btn pinkbtn">
            Back
          </Button>
        </div>
      </Col>
    </Row>
  </Container>
)
